export default __webpack_public_path__ + "static/media/Netuno.48cf14b7.png";